package it.neckar.lizergy.model.stumps

import it.neckar.lizergy.model.project.ProjectConfiguration.PhotovoltaicsProjectId
import it.neckar.uuid.NativeUuid
import kotlinx.serialization.Serializable

@Serializable
data class AdvanceInvoice(
  override val uuid: NativeUuid,
  override val projectId: PhotovoltaicsProjectId,
) : ProjectStump
